import dataPeriApi from "../../../../src/data/periprocedureel-beleid-apixaban.json";
import BasicSchematic from "../../../../src/components/chart/interaction/basic-schematic/Chart.js";
import * as React from 'react';
export default {
  dataPeriApi,
  BasicSchematic,
  React
};